import Select from "react-select";
import Remote from "./remote";

Select.Remote = Remote;
export default Select;
